import { RootState, store } from '../../index';
import { IDLE_STATUS } from '../../../utils/types/statuses';

export const checkCanLoadLanguages = (cb: () => void): void => {
  const { languages } = store.getState();
  if (languages.status === IDLE_STATUS) {
    cb();
  }
};

type TLanguagesForSelectReturn = Array<{
  value: number;
  label: string;
  code: string;
}>;

export const getLanguagesForSelect = (
  state: RootState,
): TLanguagesForSelectReturn =>
  state.languages.data.map((language) => ({
    value: language.id,
    label: language.name,
  }));
